import {
  transformFromNumberToString,
  transformFromStringToNumber,
} from 'components/modules/Insurance/Insurance.helpers';
import { DRIVER_FIELDS } from 'store/insuranceAnketa/constants';
import { genderMap } from 'store/insuranceAnketa/genderHelper';

const DEFAULT_FULL_NAME = 'Новый водитель';

const createStoreFallback = (fields, base = {}) => {
  return fields.reduce((acc, field) => {
    acc[field] ??= '';

    return acc;
  }, base);
};
const createStoreMap = (fields) => {
  return fields.reduce((acc, field) => {
    return { ...acc, [field]: field };
  }, {});
};

const BASE_FIELDS = [
  DRIVER_FIELDS.BIRTHDATE,
  DRIVER_FIELDS.DRIVING_LICENSE_ISSUE_DATE,
  DRIVER_FIELDS.DRIVING_LICENSE_SERIES_AND_NUMBER,
  DRIVER_FIELDS.FULL_NAME,
];
const ERRORS_FIELDS = [...BASE_FIELDS, DRIVER_FIELDS.DRIVING_EXPERIENCE];
const HEADER_FIELDS = [...BASE_FIELDS, DRIVER_FIELDS.ROLES];
const VALUES_FIELDS = [...BASE_FIELDS, DRIVER_FIELDS.DRIVING_EXPERIENCE, DRIVER_FIELDS.GENDER];

export const ERRORS_STORE_FALLBACK = createStoreFallback(ERRORS_FIELDS);
export const HEADER_STORE_FALLBACK = createStoreFallback(HEADER_FIELDS, {
  [DRIVER_FIELDS.FULL_NAME]: DEFAULT_FULL_NAME,
  [DRIVER_FIELDS.ROLES]: [],
});
export const VALUES_STORE_FALLBACK = createStoreFallback(VALUES_FIELDS, {
  [DRIVER_FIELDS.GENDER]: genderMap.MALE,
});

export const ERRORS_STORE_MAP = createStoreMap(ERRORS_FIELDS);
export const HEADER_STORE_MAP = createStoreMap(HEADER_FIELDS);
export const VALUES_STORE_MAP = createStoreMap(VALUES_FIELDS);

export const HEADER_STORE_TRANSFORM = {
  [DRIVER_FIELDS.FULL_NAME]: (fullName) => {
    return fullName || DEFAULT_FULL_NAME;
  },
};
export const VALUES_STORE_TRANSFORM = {
  [DRIVER_FIELDS.DRIVING_EXPERIENCE]: transformFromNumberToString,
};
export const SUBMIT_STORE_TRANSFORM = {
  [DRIVER_FIELDS.DRIVING_EXPERIENCE]: transformFromStringToNumber,
};
